import i18n from "i18next";

import { initReactI18next } from "react-i18next";

// Import translation files
import components from "assets/locales/en/components.json";
import error from "assets/locales/en/error.json";
import general from "assets/locales/en/general.json";
import login from "assets/locales/en/login.json";
import notFound from "assets/locales/en/notFound.json";

const namespacesToPreload: string[] = ["general", "components"];

i18n.use(initReactI18next).init({
  fallbackLng: ["en"],
  debug: false,
  returnObjects: true,
  interpolation: {
    escapeValue: false,
  },
  resources: {
    en: {
      components,
      error,
      general,
      login,
      notFound,
    },
  },
  lng: navigator?.languages?.[0]?.startsWith("en")
    ? navigator.languages[0]
    : "en",
  ns: namespacesToPreload,
  defaultNS: "general",
});

export default i18n;
